import React from 'react';

import { Flex } from '@adsk/alloy-react-box';
import theme from '@adsk/alloy-react-theme';

import { formatUniqueId } from '../../../../helpers';
import { Task, TaskType } from '../../../types';
import PlanTaskName from '../../PlanTaskName/PlanTaskTitle';
import TaskMilestoneIcon from '../../TaskMilestoneIcon/TaskMilestoneIcon';

interface PlanTaskEntityMenuItemLabelProps {
  task: Task;
}

const PlanTaskEntityMenuItemLabel = ({
  task,
}: PlanTaskEntityMenuItemLabelProps) => (
  <Flex alignItems="center" typography="bodyMedium" style={{ gap: '8px' }}>
    {task.type === TaskType.MILESTONE && (
      <TaskMilestoneIcon color={theme.colors.charcoal600} size={20} />
    )}
    <p style={{ color: theme.colors.adskBlue700 }}>
      {`#${formatUniqueId(task.uniqueId)}`}
    </p>
    <PlanTaskName task={task} />
  </Flex>
);

export default PlanTaskEntityMenuItemLabel;
